module.exports = __webpack_public_path__ + "img/guzhiReport.5322dc6b.png";